import { render, staticRenderFns } from "./address.vue?vue&type=template&id=bea3bae8&scoped=true"
import script from "./address.vue?vue&type=script&lang=js"
export * from "./address.vue?vue&type=script&lang=js"
import style0 from "./address.vue?vue&type=style&index=0&id=bea3bae8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea3bae8",
  null
  
)

export default component.exports